var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _ellipse, _ellipse2, _path11, _path12, _circle, _path13, _path14, _polygon, _circle2, _circle3, _circle4, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgApp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2_1_",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1200 1200",
    style: {
      enableBackground: "new 0 0 1200 1200"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n\t.st1{fill:#56CAD8;}\n\t.st2{fill:#F3F3F3;}\n\t.st3{fill:#74D5DE;}\n\t.st4{fill:#DE8E68;}\n\t.st5{fill:#FCC486;}\n\t.st6{fill:#FED385;}\n\t.st7{fill:#FED892;}\n\t.st8{fill:#2f55d4;}\n\t.st9{fill:none;stroke:#74D5DE;stroke-width:9;stroke-linecap:round;stroke-miterlimit:10;}\n")), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Artboard 1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M896.4,562v427.7c0,31.3-25.3,56.6-56.6,56.6h0H507.4c-31.3,0-56.6-25.3-56.6-56.6l0,0V141.1 c0-31.3,25.3-56.6,56.6-56.6h332.4c31.3,0,56.6,25.3,56.6,56.6v0V562"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M814.6,1064.2l-73.5-101.8c0,0-41.4-57.2-67.4-58.2c-0.2,15,0.8,122.6,5.4,159.9H814.6z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M578.2,62.1H769c8.7,0,15.7,7,15.7,15.7v24.1c0,8.7-7,15.7-15.7,15.7H578.2c-8.7,0-15.7-7-15.7-15.7V77.8 C562.5,69.2,569.5,62.1,578.2,62.1z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M882.8,1047.9h13.6V882.3l-114.6-19l-108.2,41c5.1,11.6,32,88.6,89.7,156h119.4V1047.9z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M641.7,641.7c-9.3-0.2-9.3,14.1-9.3,14.1c-4.5-13.4-102.7-257.7-102.7-257.7s-20.3,8.6,3.1,54.8 c-7.6,4.5-28.7,21.4-20,48.6c6.6,20.4,21,27.6,30,27.6c-1.5,15.3,31.2,171.6,35.5,179.1c10,17.7,29.3,37,40.7,37.5 c18.2,0.9,63-23,74.1-35.5S659.2,642,641.7,641.7z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M776.9,555.5C732.6,516,624.5,610.6,626.6,627s60.3,75.7,77.4,70.7S811.8,586.5,776.9,555.5z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M896.4,562c-19.7-31.9-48.6-52.5-90-52.5c-143.7,0-147.8,374-132.8,394.8c13.3,18.4,171.8,23.2,222.8,10.5"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M896.4,698.5l-15.1,6.2c1.3,4.8,7.1,31.7,15.1,61.4"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M896.4,558.7c-10-7.4-20.2-10.4-29.6-6.5c-54.2,22.6-15.6,158.5,0,163.5c5,1.6,16.4,0,29.6-3.5"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M834,542.3c0,11.9-65.9,14.5-65.9,0v-81H834V542.3z"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.3697 -0.9292 0.9292 0.3697 102.7826 1005.1974)",
    className: "st4",
    cx: 792.3,
    cy: 426.8,
    rx: 80.3,
    ry: 59.7
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5823 -0.813 0.813 0.5823 -17.3948 876.0408)",
    className: "st4",
    cx: 843.8,
    cy: 454.9,
    rx: 18.9,
    ry: 13.2
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M899.2,416.9c0-11-10.3-23.1-12.2-36.9c-1-7,1.2-36.1-7-46c-17-20.4-27-16.2-40-21c-22.6-8.3-31.3-22-50-22 c-21.2,0-29.8,11-45,11c-17.4,0-31.6-8-56-8c-13,0-30,17-30,32c0,35.5,33,30.4,33,39c0,6-2,10.8-2,19c0,10.8,14,17,22,17 c24.4,0,27.6-3,27.6-3c4.8-9.7,11-18.6,18.4-26.5c1-1,16.8,10.1,42.6,11c21.2,0.7,36.1,4.8,36.1,14.7c0,7-2.6,27.7-2.4,33.5 s2.2,9.6,3.5,9.6s2-1.9,10.2-1.9c8.7,0,9.4,10.7,10.9,10.7C867.7,449.1,899.2,442,899.2,416.9z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M504.5,284.8h49.9c14.8,0,26.8,12,26.8,26.8v49.9c0,14.8-12,26.8-26.8,26.8h-49.9c-14.8,0-26.8-12-26.8-26.8 v-49.9C477.7,296.8,489.7,284.8,504.5,284.8z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st8",
    cx: 568.8,
    cy: 293.1,
    r: 21.2
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M841.6,54H505.7c-45.2,0-81.9,36.7-81.9,81.9v858.8c0,45.2,36.7,81.9,81.9,81.9h0h335.9 c45.2,0,81.9-36.7,81.9-81.9V135.9C923.5,90.7,886.8,54,841.6,54z M896.4,562v427.7c0,31.3-25.3,56.6-56.6,56.6h0H507.4 c-31.3,0-56.6-25.3-56.6-56.6l0,0V141.1c0-31.3,25.3-56.6,56.6-56.6h332.4c31.3,0,56.6,25.3,56.6,56.6v0V562z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M893.6,181.1h121.3c21.9,0,39.7,17.8,39.7,39.7l0,0c0,21.9-17.8,39.7-39.7,39.7H893.6 c-21.9,0-39.7-17.8-39.7-39.7l0,0C853.9,198.8,871.7,181.1,893.6,181.1z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "901.1,242 866.7,207.5 866.7,276.5 "
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 913.3,
    cy: 222.1,
    r: 10
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 954.3,
    cy: 222.1,
    r: 10
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 995.2,
    cy: 222.1,
    r: 10
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M351.1,987.3c14.9-6.4,26.5-16.3,26.5-44.8c0-133.5-158-97.5-158-208.4"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M247.4,733.4c8.6,11.2-20.1,23.9-24.2,18.6S238.3,721.5,247.4,733.4z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M387.4,537.2c10.4,13.6-20.4,26-25.4,19.5S376.2,522.6,387.4,537.2z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M379,593.4c8.3,15-32,27.1-36,19.9S370.2,577.3,379,593.4z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M381.4,636.1c10.9,13.2-26.6,32.4-31.8,26.1S369.8,621.9,381.4,636.1z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M394.2,684c10.9,13.2-26.6,32.4-31.8,26.1S382.6,669.9,394.2,684z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M405.4,728.7c9.9,12-22.9,28.4-27.6,22.6S394.8,715.8,405.4,728.7z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M420.4,777.6c9.9,12-22.9,28.4-27.6,22.6S409.8,764.7,420.4,777.6z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M193,724.6c3.6-13.6,31.3,1.2,29.6,7.8S189.2,739.2,193,724.6z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M192.5,772.5c-1.8-13.9,29.5-10.5,30.3-3.8S194.4,787.5,192.5,772.5z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M220.1,816c-9.1-10.7,18.9-25,23.3-19.9S229.9,827.4,220.1,816z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M254.8,839.5c-5.5-12.9,25.5-18.1,28.1-11.9S260.6,853.3,254.8,839.5z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M301.3,863.9c-5.5-12.9,25.5-18.1,28.1-11.9S307.2,877.7,301.3,863.9z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M336.2,899.3c-1.2-14,29.9-9.3,30.5-2.6S337.5,914.3,336.2,899.3z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M262.5,763.5c11,8.8-13.8,28.1-19.1,23.9S250.7,754,262.5,763.5z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M287.4,788.5c12.1,7.2-9.7,29.7-15.5,26.3S274.5,780.9,287.4,788.5z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M333.1,813.1c11.4,8.2-12.5,28.7-18,24.7S320.9,804.3,333.1,813.1z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M353.9,992.5c0-5.7,48.5-58.9,48.5-125c0-107.8-60.2-161.8-60.2-238.8c0-14.6,1.3-60.4,24.5-79"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M419.8,1116.4h-88.4c-4.1,0-7.8-2.6-9.1-6.6l-44-133.3c-1.6-5,1.1-10.4,6.1-12.1c1-0.3,2-0.5,3-0.5h176.8 c5.3,0,9.6,4.3,9.6,9.6c0,1-0.2,2-0.5,3l-44.4,133.3C427.5,1113.8,423.9,1116.4,419.8,1116.4z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M434.6,833.7c5.2,14.7-31.2,18.9-33.6,11.9S429.1,817.9,434.6,833.7z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M375.2,855.3c11.5-10.4,29.5,21.5,23.9,26.5S362.8,866.5,375.2,855.3z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M365.9,815.5c7.6-13.5,34.7,11.1,31.1,17.5S357.7,830,365.9,815.5z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M357.2,768.3c7.6-13.5,34.7,11.1,31.1,17.5S349,782.8,357.2,768.3z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M341.7,730.8c5-14.8,36.2,4.3,33.8,11.4S336.3,746.5,341.7,730.8z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M319.7,679c7.3-13.8,35,10.1,31.5,16.7S312,693.8,319.7,679z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M309.4,621.4c8.5-13,34,13.3,29.9,19.5S300.3,635.4,309.4,621.4z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M314.5,571.8c8.5-13,34,13.3,29.9,19.5S305.4,585.8,314.5,571.8z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M434.6,884.7c5.2,14.7-31.2,18.9-33.6,11.9S429.1,869,434.6,884.7z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApp);
export default __webpack_public_path__ + "static/media/app.66c6c6a1ac74d296c33c01b999a4c6b2.svg";
export { ForwardRef as ReactComponent };